import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { NiceAsyncTypeaheadProvider, NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { Observable, lastValueFrom, map } from "rxjs";
import { PumpingTrucks } from "../models/pumping-trucks.model";
import { PumpingTrucksApi } from "./pumping-trucks.api";

@Injectable()
export class PumpingTrucksTypeaheadApi extends NiceAsyncTypeaheadProvider<PumpingTrucks> {
    public readonly resource = "pumpingTrucks";
    private readonly pageSize = 20;

    private readonly pumpingTrucksApi = inject(PumpingTrucksApi);
    private readonly translateService = inject(TranslateService);

    public override async getById(id: number): Promise<PumpingTrucks> {
        return lastValueFrom(this.pumpingTrucksApi.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PumpingTrucks>> {
        return this.pumpingTrucksApi
            .search({ searchQuery, page, pageSize: this.pageSize, archived: false })
            .pipe(map(items => ({ items, nextPage: items.length === this.pageSize ? page + 1 : null })));
    }

    public override format(item: PumpingTrucks): string {
        if (!item.unitNumber) {
            return "-";
        }

        return this.translateService.instant("models.pumping_trucks.unit_number", { unitNumber: item.unitNumber });
    }
}
